<script lang="ts">
    export let visible = false;
    export let btnBgColor = '#0076FF';
    export let btnColor = '#F0F0F0';
    export let btnText = 'Click me!';

    export let onBtnClick: () => void = () => null;
</script>

<div class="wrapper" class:visible class:invisible={!visible}>
    <div class="buttonContainer">
        <button
            on:click={onBtnClick}
            class="button"
            style="background-color: {btnBgColor}; color: {btnColor}"
        >
            {btnText}
        </button>
    </div>
</div>

<style lang="scss">
    .wrapper {
        position: absolute;
        font-size: 64px;
        bottom: 10px;
        left: 0;
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        box-sizing: border-box;
        z-index: 1;

        &.invisible {
            transform: translateY(70px);
        }

        &.visible {
            -webkit-animation: slide-top-fullscreen 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)
                both;
            animation: slide-top-fullscreen 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
        }

        .buttonContainer {
            width: 100%;
            max-width: 640px;
            display: flex;
            justify-self: center;
            justify-content: center;
            align-items: center;

            .button {
                padding: 18px 24px;
                border-radius: 6px;
                display: inline-block;
                cursor: pointer;
                box-shadow: 0 0 1px rgba(0, 0, 0, 0.5) inset;
                border: none;
                width: 100%;
                transition:
                    0.2s background-color,
                    0.2s transform;
                margin-bottom: 0;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }
</style>
